module.exports = __webpack_public_path__ + "img/edge_nature_jardin.8395a0b7.svg";